module.exports = __webpack_public_path__ + "static/media/ceg.e593271f.png";